export const AWS_CONTACT_US_LINK = "https://aws.amazon.com/contact-us";
